<div class="public_places_box" *ngIf="lang==='en'">
  <div class="public_places_head">
    <h4>Prominent Public Places @ Narmetta</h4>
  </div>
  <div class="public_places_body" *ngIf="publicPlacesSettings">
    <ul class="public_places_list" >

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.mosques.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.mosques.en_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/mosques']">Read More</button>
          </div>
        </div>
      </li>

      <li> 
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.churches.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.churches.en_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/churches']">Read More</button>
          </div>
        </div>
      </li>

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.parks.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.parks.en_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/parks']">Read More</button>
          </div>
        </div>
      </li>

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.temples.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.temples.en_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/temples']">Read More</button>
          </div>
        </div>
      </li>

    </ul>
  </div>


</div>


<div class="public_places_box" *ngIf="lang==='te'">
  <div class="public_places_head">
    <h4>ప్రముఖ బహిరంగ ప్రదేశాలు @ నార్మెట్టా</h4>
  </div>
  <div class="public_places_body">
    <ul class="public_places_list"  >

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.mosques.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.mosques.te_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/mosques']">Read More</button>
          </div>
        </div>
      </li>

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.churches.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.churches.te_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/churches']">Read More</button>
          </div>
        </div>
      </li>

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.parks.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.parks.te_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/parks']">Read More</button>
          </div>
        </div>
      </li>

      <li>
        <div class="media">
          <div class="media-left media-top">
            <img [src]="publicPlacesSettings.temples.image.url" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{publicPlacesSettings.temples.te_title}}</h4>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/temples']">Read More</button>
          </div>
        </div>
      </li>

    </ul>
  </div>


</div>
